<template>
  <mdb-container>
    <EditRetailer :default-marker="marker"/>
  </mdb-container>
</template>

<script>
import { mdbContainer } from "mdbvue";
import EditRetailer from "@/components/EditRetailer.vue";

export default {
  name: "AddRetailer",
  components: {
    mdbContainer,
    EditRetailer
  },
  data() {
    return {
      marker: {
        name: "Helsinki",
        position: { lat: 60.1733244, lng: 24.9410248 },
        radius: 1
      }
    };
  },
};
</script>

<style></style>
